/*
 * Geschenk-Leiter – automatische Warenkorb-Logik (Version 05.10.2026)
 *
 * Regel: Ab 2 Produkten im Warenkorb (alle Produkte zählen, Geschenke und der
 *   Order-Upsell "Prio Versand" selbst nicht)
 *   - enthält der Warenkorb mindestens ein Tierprodukt (Hunde-, Katzen- oder
 *     Pferde-Kollektionen)  ->  "Mystery-Wuff-Duo" (digitales Hunde-Geschenk)
 *   - sonst (Angler, Hawaiihemd, Halloween-Fun, ...)  ->  "Mystery-Party-Geschenk"
 *     (digitales Party Deck)
 * Immer nur EIN Geschenk, Menge 1. Fällt die Menge unter 2 oder wechselt die
 * Art des Warenkorbs, wird das Geschenk automatisch entfernt bzw. getauscht.
 *
 * Beide Geschenke kosten 0,00 € (Vergleichspreis 19,95 €) – kein Rabatt nötig,
 * dieses Skript kümmert sich nur um das Hinzufügen/Entfernen der Zeile.
 *
 * Unabhängig von Theme-Events: beobachtet alle Aufrufe von /cart/add.js,
 * /cart/change.js, /cart/update.js, /cart/clear.js – egal von welchem Skript
 * (Theme, Essential Cart Drawer, Teeinblue, etc.) sie ausgelöst werden.
 *
 * Performance/Robustheit: Bei weniger als 2 Produkten werden keine Kollektionslisten
 * geladen. Erst ab 2 Produkten werden die Tier-Kollektionen nacheinander (nicht
 * parallel, mit Wiederholung bei 429) geprüft, pro Kollektion 24 Stunden in
 * localStorage gecacht, Abbruch beim ersten Treffer. Schlägt die Erkennung fehl,
 * wird ein vorhandenes Geschenk nicht verändert und es wird erneut versucht.
 */
(function () {
  'use strict';

  var GIFTS = {
    dog:   { variantId: 65410895479133, productId: 16372658405725, key: 'wuff-duo' },
    party: { variantId: 62980037116253, productId: 15792266150237, key: 'party-deck' }
  };
  // Tierprodukte: Hunde-, Katzen- und Pferde-Kollektionen
  var PET_COLLECTION_HANDLES = [
    'hundeliebe', 'hundebestseller', 'hunde-fun', 'halloween', 'hundeportraits',
    'katzen-liebhaber', 'pferde'
  ];
  var REQUIRED_QTY = 2;
  var SYNC_MARKER = '_wuffgift_sync=1';
  var CACHE_PREFIX = 'wuffgift_pet_v4_'; // pro Kollektion, 04.10.2026
  var CACHE_TTL_MS = 24 * 60 * 60 * 1000; // 24 Stunden
  var MAX_PAGES = 4;
  var MAX_ATTEMPTS = 3;      // Versuche pro Kollektion bei 429/Netzwerkfehler
  var MAX_UNKNOWN_RETRIES = 3; // Neuversuche, wenn die Tier-Erkennung nicht klappt

  // Order-Upsell "Prio Versand" (Essential Cart Drawer): zählt nicht als Produkt
  var IGNORED = { productId: 16462603092317, variantId: 65704353366365 };

  var syncing = false;
  var pendingResync = false;
  var unknownRetries = 0;
  var memoryIds = {}; // handle -> Set (nur diese Sitzung)

  function isGiftItem(item) {
    return item.product_id === GIFTS.dog.productId || item.product_id === GIFTS.party.productId ||
           item.variant_id === GIFTS.dog.variantId || item.variant_id === GIFTS.party.variantId;
  }

  // Positionen, die weder Geschenk noch zählendes Produkt sind (Prio Versand)
  function isIgnoredItem(item) {
    return item.product_id === IGNORED.productId || item.variant_id === IGNORED.variantId;
  }

  function readCache(handle) {
    try {
      var raw = localStorage.getItem(CACHE_PREFIX + handle);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (parsed && Array.isArray(parsed.ids) && (Date.now() - parsed.ts) < CACHE_TTL_MS) {
        return parsed.ids;
      }
    } catch (e) {}
    return null;
  }

  function writeCache(handle, ids) {
    try {
      localStorage.setItem(CACHE_PREFIX + handle, JSON.stringify({ ids: ids, ts: Date.now() }));
    } catch (e) {}
  }

  function wait(ms) {
    return new Promise(function (resolve) { setTimeout(resolve, ms); });
  }

  // Eine Seite einer Kollektion laden; bei 429/Fehlern bis zu MAX_ATTEMPTS Mal wiederholen.
  // Liefert { ok: true, products: [...] } oder { ok: false }
  function fetchPage(handle, n, attempt) {
    return fetch('/collections/' + handle + '/products.json?limit=250&page=' + n)
      .then(function (res) {
        if (res.ok) {
          return res.json().then(function (data) {
            return { ok: true, products: (data && data.products) || [] };
          });
        }
        if ((res.status === 429 || res.status >= 500) && attempt < MAX_ATTEMPTS) {
          return wait(600 * attempt).then(function () { return fetchPage(handle, n, attempt + 1); });
        }
        return { ok: false };
      })
      .catch(function () {
        if (attempt < MAX_ATTEMPTS) {
          return wait(600 * attempt).then(function () { return fetchPage(handle, n, attempt + 1); });
        }
        return { ok: false };
      });
  }

  // Alle Produkt-IDs einer Kollektion (seitenweise). Liefert Set oder null bei Fehler.
  function loadCollectionIds(handle) {
    if (memoryIds[handle]) return Promise.resolve(memoryIds[handle]);
    var cached = readCache(handle);
    if (cached) {
      memoryIds[handle] = new Set(cached);
      return Promise.resolve(memoryIds[handle]);
    }
    var ids = [];
    function page(n) {
      return fetchPage(handle, n, 1).then(function (result) {
        if (!result.ok) return null;
        result.products.forEach(function (p) { ids.push(p.id); });
        if (result.products.length >= 250 && n < MAX_PAGES) return page(n + 1);
        return ids;
      });
    }
    return page(1).then(function (list) {
      if (!list) return null; // Fehler: nichts cachen
      writeCache(handle, list);
      memoryIds[handle] = new Set(list);
      return memoryIds[handle];
    });
  }

  // Prüft nacheinander die Tier-Kollektionen. Frühzeitiger Abbruch beim ersten Treffer.
  // Liefert { has: boolean, complete: boolean }
  function detectPet(productIds) {
    var complete = true;
    function next(i) {
      if (i >= PET_COLLECTION_HANDLES.length) return Promise.resolve({ has: false, complete: complete });
      return loadCollectionIds(PET_COLLECTION_HANDLES[i]).then(function (set) {
        if (!set) {
          complete = false;
        } else {
          for (var k = 0; k < productIds.length; k++) {
            if (set.has(productIds[k])) return { has: true, complete: true };
          }
        }
        return next(i + 1);
      });
    }
    return next(0);
  }

  function cartPost(path, payload) {
    return fetch(path + '?' + SYNC_MARKER, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    });
  }

  // Aufgaben nacheinander ausführen (kein paralleles Ändern des Warenkorbs)
  function runSequential(tasks) {
    return tasks.reduce(function (chain, task) {
      return chain.then(function () { return task(); });
    }, Promise.resolve());
  }

  // pet: { has: boolean, complete: boolean } oder null (wenn unter 2 Produkten)
  function decideAndApply(cart, pet) {
    var realQty = 0;
    var giftLines = [];

    (cart.items || []).forEach(function (item) {
      if (isGiftItem(item)) {
        giftLines.push(item);
      } else if (!isIgnoredItem(item)) {
        realQty += item.quantity;
      }
    });

    var qualifies = realQty >= REQUIRED_QTY;
    var wanted = null;
    if (qualifies) {
      if (pet && pet.has) {
        wanted = GIFTS.dog;
      } else if (pet && !pet.complete && unknownRetries < MAX_UNKNOWN_RETRIES) {
        // Tier-Erkennung unsicher (z. B. Netzwerkfehler): nichts ändern, bald erneut versuchen
        unknownRetries++;
        setTimeout(syncGift, 2500);
        return Promise.resolve(false);
      } else {
        wanted = GIFTS.party;
      }
    }
    if (!pet || pet.complete || pet.has) unknownRetries = 0;
    var tasks = [];

    var keep = null; // die eine Zeile, die bleiben darf
    giftLines.forEach(function (line) {
      var isWanted = wanted && line.variant_id === wanted.variantId;
      if (isWanted && !keep) {
        keep = line;
        if (line.quantity !== 1) {
          tasks.push(function () { return cartPost('/cart/change.js', { id: line.key, quantity: 1 }); });
        }
      } else {
        // falsches Geschenk, überzählige Zeile oder Warenkorb qualifiziert nicht mehr
        tasks.push(function () { return cartPost('/cart/change.js', { id: line.key, quantity: 0 }); });
      }
    });

    if (wanted && !keep) {
      tasks.push(function () {
        return cartPost('/cart/add.js', {
          items: [{ id: wanted.variantId, quantity: 1, properties: { _auto_gift: wanted.key } }]
        });
      });
    }

    if (tasks.length === 0) return Promise.resolve(false);
    return runSequential(tasks).then(function () { return true; });
  }

  function syncGift() {
    if (syncing) {
      pendingResync = true;
      return;
    }
    syncing = true;

    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = cart.items || [];
        var realQty = 0;
        items.forEach(function (i) { if (!isGiftItem(i) && !isIgnoredItem(i)) realQty += i.quantity; });

        // Unter 2 Produkten: Kollektionen gar nicht erst laden
        if (realQty < REQUIRED_QTY) return decideAndApply(cart, null);

        var productIds = items.filter(function (i) { return !isGiftItem(i) && !isIgnoredItem(i); })
                              .map(function (i) { return i.product_id; });
        return detectPet(productIds).then(function (pet) {
          return decideAndApply(cart, pet);
        });
      })
      .then(function (changed) {
        if (changed) {
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          document.dispatchEvent(new CustomEvent('cart:update'));
        }
      })
      .catch(function (e) {
        console.error('[Geschenk-Leiter] Sync-Fehler:', e);
      })
      .finally(function () {
        syncing = false;
        if (pendingResync) {
          pendingResync = false;
          syncGift();
        }
      });
  }

  // Alle Warenkorb-Ajax-Aufrufe beobachten, unabhängig von der Quelle (Theme, Apps, Widgets)
  var originalFetch = window.fetch;
  window.fetch = function () {
    var args = arguments;
    var url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
    var isOwnSyncCall = url.indexOf(SYNC_MARKER) !== -1;
    var isCartMutation = /\/cart\/(add|change|update|clear)(\.js)?/.test(url);
    var promise = originalFetch.apply(this, args);
    if (isCartMutation && !isOwnSyncCall) {
      promise.then(function () {
        setTimeout(syncGift, 250);
      });
    }
    return promise;
  };

  function init() {
    syncGift();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('pageshow', syncGift);
})();